/**
 * PayerService
 * Service for Payer entity operations
 * Route: api/payer
 * Controller: PayerController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * PayerService
 * Handles payer CRUD operations and model view queries
 * Maps to /api/payer endpoint
 */
export class PayerService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? PayerService.DEFAULT_SERVICE_PATH,
            basePath: PayerService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // Override getById to support GUID
    async getById(id) {
        const response = await this.getByIdRaw(id);
        if (!response.data) {
            throw new Error(`Payer with ID ${id} not found`);
        }
        return response.data;
    }
    getByIdRaw(id) {
        const url = this.buildUrl(id);
        return this.http.get(url);
    }
    // ==================== CACHE INVALIDATION ====================
    /**
     * Invalidate payer cache
     * POST /api/payer/cache/invalidate
     */
    async invalidateCache() {
        const response = await this.invalidateCacheRaw();
        return response.data ?? false;
    }
    /**
     * Invalidate payer cache (raw)
     */
    invalidateCacheRaw() {
        const endpoint = this.getEndpoint('cache-invalidate', 'cache/invalidate');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, {});
    }
    // ==================== MODEL VIEW ENDPOINTS ====================
    /**
     * Get payer model view by ID
     * GET /api/payer/view/{id}
     */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data) {
            throw new Error(`Payer view with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get payer model view by ID (raw)
     */
    getViewRaw(id) {
        const url = this.buildUrl(`view/${id}`);
        return this.http.get(url);
    }
    /**
     * Get all payer model views
     * GET /api/payer/view
     */
    async getAllViews() {
        const response = await this.getAllViewsRaw();
        return response.data ?? [];
    }
    /**
     * Get all payer model views (raw)
     */
    getAllViewsRaw() {
        const url = this.buildUrl('view');
        return this.http.get(url);
    }
}
PayerService.DEFAULT_SERVICE_PATH = 'payments';
PayerService.BASE_PATH = 'api/payer';
//# sourceMappingURL=PayerService.js.map